import React from "react";
import { Icon } from "@chakra-ui/icons";

import { ReactComponent as ArrowDownLineIcon } from "../../assets/arrow-down-line.svg";

export const ArrowDownLine = (props) => {
  return <Icon as={ArrowDownLineIcon} {...props} />;
};
